var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QRcode",style:({'width':_vm.width,'height':_vm.height})},[_c('canvas',{staticStyle:{"margin":"0 auto"},style:({'width':_vm.width,'height':_vm.height}),attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }